<div class="modal-body">
    <div class="container">
        <p>Por favor, complete la información acerca del nuevo poder.</p>

        <form #powersForm="ngForm" class="form-horizontal">

            <!-- Buttons -->
            <button
            type="button"
            class="btn"
            [ngClass]="{
                'btn-outline-primary': !isRecipmentComplete(),
                'btn-outline-success': isRecipmentComplete()
            }"
            (click)="toggleCollapse('recipment')"
            [attr.aria-expanded]="!isRecipmentCollapsed"
            aria-controls="collapseRecipment"
            >
            Apoderado
            </button>

            <button
            type="button"
            class="btn"
            [ngClass]="{
                'btn-outline-secondary': !isRecipmentComplete(),
                'btn-outline-success': isRecipmentComplete()
            }"
            (click)="toggleCollapse('issuer')"
            [attr.aria-expanded]="!isIssuerCollapsed"
            aria-controls="collapseIssuer"
            >
            Poderdante
            </button>

            <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="toggleCollapse('property')"
            [attr.aria-expanded]="!isPropertyCollapsed"
            aria-controls="collapseProperty"
            >
            Escritura
            </button>

            <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="toggleCollapse('detail')"
            [attr.aria-expanded]="!isDetailCollapsed"
            aria-controls="collapseDetail"
            >
            Detalles
            </button>

            <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="toggleCollapse('preview')"
            [attr.aria-expanded]="!collapseStates['preview']"
            aria-controls="collapsePreview"
            >
            Vista Previa
            </button>

            <!-- collapse Section -->
        
            <div id="collapseRecipment" [(ngbCollapse)]="collapseStates['recipment']">
                <div class="card form-group mt-3">
                    <h4>Apoderado</h4>
                    <label class="control-label" for="tenancy_name">Nombre del apoderado:</label>
                    <input
                        class="form-control"
                        type="text"
                        [(ngModel)]="powersOfAttorney.tenancy.name"
                        name="tenancy_name"
                        id="tenancy_name"
                        required
                        #tenancy_name="ngModel"
                    />
                    <label for="tenancy_taxid">RFC del apoderado:</label>
                    <input class="form-control" 
                        type="text" [(ngModel)]="powersOfAttorney.tenancy.taxid" 
                        id="tenancy_taxid"
                        name="tenancy_taxid" #tenancy_taxid="ngModel"/>
                </div>

                <div class="card form-group">
                    <label class="control-label" for="tanancy_zip">Código Postal del apoderado:</label>
                    <input
                        class="form-control"
                        type="text"
                        [(ngModel)]="powersOfAttorney.tenancy.zip"
                        name="tanancy_zip"
                        id="tenancy_zip"
                        required
                        #tanancy_zip="ngModel"
                    />
                </div>
                <div class="card form-group">
                    <label for="tenancy_pdf" class="control-label">Documento de identificación del apoderado:</label>
                    <input id="tenancy_pdf" name="tenancy_pdf" type="file"
                        (change)="onTenancyPdfSelected($event)"
                        accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png" />
                    <small *ngIf="tenancyPdfLabel" class="text-muted d-block">{{ tenancyPdfLabel }}</small>
                </div>

            </div>
            
            <div id="collapseIssuer" [(ngbCollapse)]="collapseStates['issuer']">
                <div class="card form-group mt-3">
                    <h4>Nombre de la sociedad Poderdante</h4>
                    <app-society-selector [message]="'Buscar sociedad...'" [selectedSociety]="selectedSociety" 
                        (societySelected)="onSocietySelected($event)">
                    </app-society-selector>
                    <h6>Sociedad:</h6> {{ selectedSocietyInParent }}
                    <!-- <h6>Notario</h6> -->

                    <!-- State dropdown -->
                    <div class="form-group">
                        <label for="stateSelect">Estado donde se expide el poder</label>
                        <select id="stateSelect" class="form-select" [(ngModel)]="selectedState" name="stateSelect" (change)="filterNotaries()">
                        <option *ngFor="let state of (groupedNotariesByState | keyvalue)" [value]="state.key">
                            {{ state.key }}
                        </option>
                        </select>
                    </div>
                    
                    <!-- Notary name search -->
                    <div class="form-group">
                        <input class="form-control" type="text" placeholder="Filtrar notarios por nombre..." [(ngModel)]="searchNotaryName" name="searchNotaryName" (input)="filterNotaries()">
                    </div>
                    
                    <!-- Filtered notaries -->
                    <div class="form-group">
                        <label class="control-label" for="public_notary">Notario que protocoliza el poder</label>
                        <select class="form-select" name="public_notary" id="public_notary" [(ngModel)]="powersOfAttorney.public_notary.id" required #public_notary="ngModel">
                        <option *ngFor="let item of filteredNotaries" [value]="item.id">
                             {{ item.state | capitalize }} - {{ item.num }} - {{ item.name | capitalize}}
                        </option>
                        </select>
                    </div>
  

                    <!-- <div class="form-group">
                        <label class="control-label" for="public_notary">Notario 1</label>
                        <select class="form-select" name="public_notary" id="public_notary" [(ngModel)]="powersOfAttorney.public_notary.id" required #public_notary="ngModel">
                            <option *ngFor="let item of powerCatalog_PublicNotary | async" [value]="item.id">
                                {{ item.name }} - {{ item.num }} - {{ item.state }}
                            </option>
                        </select>
                    </div> -->


                </div>

            </div>
            
            <div id="collapseProperty" [(ngbCollapse)]="collapseStates['property']">
                <div class="card form-group mt-3">
                     <h4>Datos de la Escritura</h4>
                     <div class="form-group">
                        <label class="control-label" for="real_state_id"># Escritura:</label>
                        <input
                            class="form-control"
                            type="text"
                            [(ngModel)]="powersOfAttorney.real_state.id"
                            name="real_state_id"
                            id="real_state_id"
                            required
                            #real_state_id="ngModel"
                        />
                    </div>

                    <div class="form-group">
                        <label for="real_state_date">Fecha</label>
                        <input type="date" class="form-control" 
                        [(ngModel)]="powersOfAttorney.real_state.date" 
                        name="real_state_date" 
                        id="real_state_date" required #real_state_date="ngModel">
                    </div>

                    <div class="form-group">
                        <label for="real_state_zip">Código Postal</label>
                        <input class="form-control" type="text" name="real_state_zip" id="real_state_zip" 
                        [(ngModel)]="powersOfAttorney.real_state.zip" #real_state_zip="ngModel"
                        />
                    </div>

                </div>
            </div>
        
            <div id="collapseDetail" [(ngbCollapse)]="collapseStates['detail']">
                <div class="card form-group mt-3">
                    <h4>Detalles</h4>
                    <div class="form-group">
                        <label for="power_type">Tipo de Poder</label>
                        <select class="form-select" name="type" id="power_type" [(ngModel)]="powersOfAttorney.type" required #type="ngModel">
                            <option *ngFor="let item of powerCatalogData_type | async" [value]="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
    
    
                    <div class="form-group">
                        <label class="control-label" for="extension">Ejercicio</label>
                        <select class="form-select" name="extension" id="extension" [(ngModel)]="powersOfAttorney.extension" required #extension="ngModel">
                            <option *ngFor="let item of powerCatalogData_extension | async" [value]="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
    
                    <div class="form-group">
                        <label class="control-label" for="attributes">Atributos</label>
                        <select class="form-select" name="attribute" id="attribute" multiple [(ngModel)]="powersOfAttorney.attributes" required #attributes="ngModel">
                            <option *ngFor="let item of powerCatalogData_attributes | async" [value]="item.id">
                                {{ item.short_name }} - {{ item.name }}
                            </option>
                        </select>
                    </div>
    
                    <div class="form-group">
                        <label class="control-label" for="limits">Límites</label>
                        <textarea class="form-control" name="limits" id="limits" [(ngModel)]="powersOfAttorney.limits" required #limits="ngModel"></textarea>
                    </div>
    
                    <div class="form-group">
                        <label for="comments">Comentarios</label>
                        <textarea class="form-control" name="comments" id="comments" [(ngModel)]="powersOfAttorney.comments" required #comments="ngModel"></textarea>
                    </div>
        
                    <h6>Vigencia</h6>
                    <div class="form-group">
                        <label for="start_at">Inicio</label>
                        <input type="date" class="form-control" [(ngModel)]="powersOfAttorney.start_at" name="start_at" id="start_at" required #start_at="ngModel">
                    </div>
        
                    <div class="form-group">
                        <label for="end_at">Fin</label>
                        <input type="date" class="form-control" [(ngModel)]="powersOfAttorney.end_at" name="end_at" id="end_at" required #end_at="ngModel">
                        <input type="hidden" name="userTaxid" id="taxid" [(ngModel)]="powersOfAttorney.userTaxid">
                    </div>
        
                    <div *ngIf="!validateDateRange() && powersOfAttorney.start_at && powersOfAttorney.end_at" class="text-danger">
                        La fecha de fin debe ser al menos {{ minDaysPower }} días posterior a la fecha de inicio.
                    </div>
                    
                    <div class="card form-group">
                        <label for="original_pdf" class="control-label">Documento del poder (original):</label>
                        <input id="original_pdf" name="original_pdf" type="file"
                            (change)="onOriginalPdfSelected($event)"
                            accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png" />
                        <small *ngIf="originalPdfLabel" class="text-muted d-block">{{ originalPdfLabel }}</small>
                    </div>

                    <div class="card form-group">
                        <label for="registered_pdf" class="control-label">Documento del poder registrado:</label>
                        <input id="registered_pdf" name="registered_pdf" type="file"
                            (change)="onRegisteredPdfSelected($event)"
                            accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png" />
                        <small *ngIf="registeredPdfLabel" class="text-muted d-block">{{ registeredPdfLabel }}</small>
                    </div>
    
                </div>
            </div> <!--collpse detail -->

            <div id="collapsePreview" [(ngbCollapse)]="collapseStates['preview']">
                <div class="card form-group mt-3">
                     <h4>Vista previa</h4>
                     <p>
                        Recibe el poder: {{ powersOfAttorney.tenancy.name}}
                     </p>
                    
                </div>
            </div>    
        
        </form>
    </div>
</div>

<div class="modal-footer">
    <div *ngIf="docFileError" class="text-danger w-100 small mb-2">{{ docFileError }}</div>
    <button type="button" class="btn btn-outline-dark" (click)="closeModalWithoutResult()">Cerrar</button>
    <button type="button" class="btn btn-primary" (click)="closeModalWithResult()" [disabled]="!powersForm.valid|| !validateDateRange()">
        Guardar
    </button>
    <!-- <div *ngIf="signatories.email_person">
      <button type="button" class="btn btn-success btn-outline-dark" (click)="closeModalWithResult()">Agregar</button>
    </div> -->
    <!-- <button type="button" class="btn btn-success btn-outline-dark" (click)="closeModalWithResult()">Agregar</button> -->
    <!-- <div *ngIf="isFormComplete()">
        <button  type="button" class="btn btn-success btn-outline-dark" (click)="closeModalWithResult()">Terminar</button>
    </div> -->
</div>
